
// TODO: if Android, window.open

import React, { useEffect, useState,useRef } from "react";
import loadingIcon from "../../Assets/loading.gif";
import queryString from "query-string";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
// import AppleIcon from "@material-ui/icons/Apple";
// import AndroidIcon from "@material-ui/icons/Android";
import {
  Apple as AppleIcon,
  Android as AndroidIcon,
} from "@mui/icons-material";
import mixpanel from "mixpanel-browser";
import { isAndroid, isIOS } from "react-device-detect";
import userStore from "../../Stores/User";
import { observer } from "mobx-react";

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_URL;

const SetupNew = observer((props) => {
  const [feedUrl, setFeedUrl] = useState(
    queryString.parse(props.location.search).feed_url
  );
  const isOnboarding = queryString.parse(props.location.search).is_onboarding;
  const { isSignedIn, userFeedUrl } = userStore;

  useEffect(() => {
    mixpanel.track("Open Choose Device Page (Onboarding)");
  }, []);

  if (isSignedIn === false && !feedUrl) {
    return <Redirect to={"signin?redirected_from=setupnew"} />;
  }

  const getRedirectUrl = (type) => {
    return `/setupnew/${type}?feed_url=${encodeURIComponent(
      userFeedUrl
    )}&is_onboarding=${isOnboarding}`;
  };


  if (isIOS){
    if (userFeedUrl) {
      return <Redirect to={getRedirectUrl("ios")} />;
    } else if (feedUrl) {
      return <Redirect to={`/setupnew/ios?feed_url=${encodeURIComponent(feedUrl)}&is_onboarding=${isOnboarding}`} />;
    }
  } else {
    if (userFeedUrl) {
      // TODO
      return <Redirect to={getRedirectUrl("android")} />;
    } else if (feedUrl) {
      return <Redirect to={`/setupnew/android?feed_url=${encodeURIComponent(feedUrl)}&is_onboarding=${isOnboarding}`} />;
    }
  }
  // if (isIOS && userFeedUrl) {
  //   return <Redirect to={getRedirectUrl("ios")} />;
  // } else if (isAndroid && userFeedUrl) {
  //   return <Redirect to={getRedirectUrl("android")} />;
  // }
// )

  return (
    <div className="center">
      {!userFeedUrl ? (
        <div className="center">
          <h1 className="headline">Loading Your Private RSS feed... </h1>
          <h2 className="subheadline">{feedUrl}</h2>
          <div>
            <img src={loadingIcon} style={{height: '50px'}}></img>
          </div>
        </div>
      ) : (
        <div className="center">
          <h1 className="headline">Choose Your Device </h1>
          <Link
            to={getRedirectUrl("ios")}
            className="transparent-button"
            onClick={(e) => {
              mixpanel.track("Choose iOS (Onboarding)");
            }}
          >
            <div className="content">
              <AppleIcon className="icon"></AppleIcon>
              <span>iPhone/iPad</span>
            </div>
          </Link>
          <Link
            to={getRedirectUrl("android")}
            className="transparent-button"
            onClick={(e) => {
              mixpanel.track("Choose Android (Onboarding)");
            }}
          >
            <div className="content">
              <AndroidIcon className="icon"></AndroidIcon>
              <span>Android</span>
            </div>
          </Link>
        </div>
      )}
    </div>
  );
});
export default SetupNew;
